// dateFormats.js
export const DATE_DISPLAY_FORMAT = 'DD/MM/YYYY'
export const DATE_DISPLAY_FORMAT_HOURS = 'hh:mm - DD/MM/YYYY'

export const MIN_COLUMN_WIDTH = '60px'
export const NORMAL_COLUMN_WIDTH = '120px'
export const BIG_COLUMN_WIDTH = '160px'
export const VERY_BIG_COLUMN_WIDTH = '200px'
export const EXTRA_BIG_COLUMND_WITDTH = '250px'